module.exports = __webpack_public_path__ + "img/jp3@2x.171479fa.png";